<div class="card-inner-main-div mt-4">
    <div class="card-main-title d-flex">
        <h4 class="card-title">{{ 'Exposure By' | translate }}</h4><a class="exposure-drop-down"
            (click)="toggleTaskRequest()">{{ (taskRequestType == 'group' ? 'Task Group' : 'Task') | translate }}
            <i class="material-icons right">expand_more</i></a>
    </div>
    <div class="circle-graph-div" id="taskExposureChart"></div>
</div>